/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse20010 from '../model/InlineResponse20010';
import InlineResponse20011 from '../model/InlineResponse20011';
import InlineResponse2009 from '../model/InlineResponse2009';

/**
* AceDocuments service.
* @module api/AceDocumentsApi
* @version 1.0.0
*/
export default class AceDocumentsApi {

    /**
    * Constructs a new AceDocumentsApi. 
    * @alias module:api/AceDocumentsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get ACE data for a student and academic program
     * Get ACE document data for a specific student and academic program
     * @param {Number} id Student ID
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2009} and HTTP response
     */
    getAceDataWithHttpInfo(id, academicProgramId) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getAceData");
      }
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling getAceData");
      }

      let pathParams = {
        'id': id,
        'academic_program_id': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2009;
      return this.apiClient.callApi(
        '/account/ace-documents/students/{id}/academic-programs/{academic_program_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get ACE data for a student and academic program
     * Get ACE document data for a specific student and academic program
     * @param {Number} id Student ID
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2009}
     */
    getAceData(id, academicProgramId) {
      return this.getAceDataWithHttpInfo(id, academicProgramId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Store ACE document
     * Store a new ACE document for a student and academic program
     * @param {Number} id Student ID
     * @param {Number} academicProgramId Academic Program ID
     * @param {Object} opts Optional parameters
     * @param {File} opts.files Document file
     * @param {String} opts.moreInfo Additional information
     * @param {String} opts.comments Comments
     * @param {Boolean} opts.replica Whether this is a replica
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse20010} and HTTP response
     */
    storeAceDocumentWithHttpInfo(id, academicProgramId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling storeAceDocument");
      }
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling storeAceDocument");
      }

      let pathParams = {
        'id': id,
        'academic_program_id': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'files': opts['files'],
        'more_info': opts['moreInfo'],
        'comments': opts['comments'],
        'replica': opts['replica']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse20010;
      return this.apiClient.callApi(
        '/account/ace-documents/students/{id}/academic-programs/{academic_program_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Store ACE document
     * Store a new ACE document for a student and academic program
     * @param {Number} id Student ID
     * @param {Number} academicProgramId Academic Program ID
     * @param {Object} opts Optional parameters
     * @param {File} opts.files Document file
     * @param {String} opts.moreInfo Additional information
     * @param {String} opts.comments Comments
     * @param {Boolean} opts.replica Whether this is a replica
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse20010}
     */
    storeAceDocument(id, academicProgramId, opts) {
      return this.storeAceDocumentWithHttpInfo(id, academicProgramId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Update ACE document
     * Update an existing ACE document for a student
     * @param {Number} id ACE Document ID
     * @param {File} files New document file (max 20 MB)
     * @param {Object} opts Optional parameters
     * @param {String} opts.moreInfo Additional information
     * @param {String} opts.comments Comments
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse20011} and HTTP response
     */
    updateAceDocumentWithHttpInfo(id, files, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateAceDocument");
      }
      // verify the required parameter 'files' is set
      if (files === undefined || files === null) {
        throw new Error("Missing the required parameter 'files' when calling updateAceDocument");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'files': files,
        'more_info': opts['moreInfo'],
        'comments': opts['comments']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse20011;
      return this.apiClient.callApi(
        '/account/ace-documents/documents/{id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Update ACE document
     * Update an existing ACE document for a student
     * @param {Number} id ACE Document ID
     * @param {File} files New document file (max 20 MB)
     * @param {Object} opts Optional parameters
     * @param {String} opts.moreInfo Additional information
     * @param {String} opts.comments Comments
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse20011}
     */
    updateAceDocument(id, files, opts) {
      return this.updateAceDocumentWithHttpInfo(id, files, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
